import {useMutation} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type SupportRequestPayload = components['schemas']['SupportRequest']

/** No auth: the token is the proof. A 400 (expired or reused token) is normal and the page handles it (PYTHON-1X). */
export function useVerifyEmail() {
  return useMutation({
    mutationFn: async (token: string) => {
      await api.post('/auth/verify-email', {token})
    },
    meta: {manejaError: true},
  })
}

export function useResendVerification() {
  return useMutation({
    mutationFn: async () => {
      await api.post('/auth/resend-verification')
    },
  })
}

/** Public: recovery without email, an administrator resets the password. */
export function useSupportRequest() {
  return useMutation({
    mutationFn: async (payload: SupportRequestPayload) => {
      await api.post('/auth/support-request', payload)
    },
  })
}
